import api from '@/api'
import * as TYPES from './mutation-types'

export default {
  [TYPES.CASE] ({ state, currentCase }) {
    console.log('ssdjknskdvnksdv')
    state.currentCase = currentCase
  },

  [TYPES.FETCH_DATA] ({ state }) {
    console.log(state)
  },

  [TYPES.FETCH_FORM] ({ state }) {
    api.get('form').then(({ data }) => {
      state.form = data.data
    }, (error) => {
      console.log(error)
    })
  },

  [TYPES.FETCH_SURVEY] ({ state }) {
    api.get('survey').then(({ data }) => {
      state.survey = data.data
    }, (error) => {
      console.log(error)
    })
  },
  [TYPES.DOWNLOAD_FILE] ({ state }, { file }) {
    api.get('file/' + file.hash, {responseType: 'blob'}).then(({ data }) => {
      let blob = new Blob([data], { type: file.type })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = file.filename
      link.click()
      state.downloadable = link
    }, (error) => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js